import './App.css';
import Header from './components/Header';
import Login from './components/Login';
import Math from './components/Math';
import Subscriptions from './components/Subscriptions';
import { useEffect, useState } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

function App() {
  const [user, setUser] = useState(null);
  const [suscripciones, setSuscripciones] = useState([]);

  useEffect(() => {
    // Escuchar cambios en el estado de autenticación
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Función para cerrar sesión
  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
  };

  // Función para añadir una suscripción desde el modal
  const handleAddSuscripcion = (nuevaSuscripcion) => {
    setSuscripciones((prev) => [
      ...prev,
      { ...nuevaSuscripcion, id: Date.now() }
    ]);
    // Aquí también puedes guardar en tu base de datos
  };

  return (
    <div>
      {user ? (
        <>
          <Header
            onAddSuscripcion={handleAddSuscripcion}
            onLogout={handleLogout}
          />
          <Math />
          <Subscriptions suscripciones={suscripciones} />
        </>
      ) : (
        <Login />
      )}
    </div>
  );
}

export default App;
